<template>
  <div>
    <Navbar />
    <b-card class="col-12" title="">
      <b-row>
        <b-tabs class="col-12" content-class="mt-3">
          <b-tab @click="resetstuff" class="border-0">
            <template v-slot:title>
              <div class="text-center">
              <fa-icon
                name="user"
              /><br>Users
              </div>
            </template>
            <b-card class="border-0 mx-auto px-0 col-12">
            <Consultants />
            </b-card>
          </b-tab>
          <b-tab lazy class="border-0">
            <template v-slot:title>
              <div class="text-center">
                <fa-icon
                  name="users"
                /><br>Companies
              </div>
            </template>
            <b-card class="border-0 mx-auto px-0 col-12">
            <Companies />
            </b-card>
          </b-tab>
          <b-tab lazy class="px-0 col-12 border-0">
            <template v-slot:title>
              <div class="text-center">
                <fa-icon
                  name="handshake"
                /><br>Partners
              </div>
            </template>
            <b-card class="border-0 mx-auto px-0 col-12">
            <Partners />
            </b-card>
          </b-tab>
          <b-tab lazy class="px-0 col-12 border-0">
            <template v-slot:title>
              <div class="text-center">
                <fa-icon
                  name="trash-alt"
                /><br>GDPR Erase
              </div>
            </template>
            <b-card class="border-0 mx-auto px-0 col-12">
            <GDPRErase />
            </b-card>
          </b-tab>
          <b-tab lazy class="px-0 col-12 border-0">
            <template v-slot:title>
              <div class="text-center">
                <fa-icon
                  name="file-invoice"
                /><br>Invoicing
              </div>
            </template>
            <b-card class="border-0 mx-auto px-0 col-12">
              <InvoiceReport />
            </b-card>
          </b-tab>
          <b-tab lazy class="px-0 col-12 border-0">
            <template v-slot:title>
              <div class="text-center">
                <fa-icon
                  name="tag"
                /><br>Coupons
              </div>
            </template>
            <b-card class="border-0 mx-auto px-0 col-12">
              <Maintenance tablename="g_consultant_coupons" />
            </b-card>
          </b-tab>          
          <b-tab lazy class="px-0 col-12 border-0">
            <template v-slot:title>
              <div class="text-center">
                <fa-icon
                  name="graduation-cap"
                /><br>Tutorials
              </div>
            </template>
            <b-card class="border-0 mx-auto px-0 col-12">
              <Tutorials />
            </b-card>
          </b-tab>
          <b-tab lazy class="px-0 col-12 border-0">
            <template v-slot:title>
              <div class="text-center">
                <fa-icon
                  name="file-alt"
                /><br>Materials
              </div>
            </template>
            <b-card class="border-0 mx-auto px-0 col-12">
              <Materials />
            </b-card>
          </b-tab>
          <!-- <b-tab lazy class="px-0 col-12 border-0">
            <template v-slot:title>
              <div class="text-center">
                <fa-icon
                  name="question"
                /><br>FAQ
              </div>
            </template>
            <b-card class="border-0 mx-auto px-0 col-12">
              <Maintenance tablename="g_faq" />
            </b-card>
          </b-tab>           -->
          <b-tab lazy class="px-0 col-12 border-0">
            <template v-slot:title>
              <div class="text-center">
                <fa-icon
                  name="cog"
                /><br>Settings
              </div>
            </template>
            <b-card class="border-0 mx-auto px-0 col-12">
              <SystemSettings />
            </b-card>
          </b-tab>
          <!-- <b-tab lazy class="px-0 col-12 border-0">
            <template v-slot:title>
              <div class="text-center">
                <fa-icon
                  name="life-ring"
                /><br>Support issues
              </div>
            </template>
            <b-card class="border-0 mx-auto px-0 col-12">
              <Maintenance tablename="g_supportissues" />
            </b-card>
          </b-tab>  -->
          <!-- <b-tab lazy class="px-0 col-12 border-0">
            <template v-slot:title>
              <div class="text-center">
                <fa-icon
                  name="address-card"
                /><br>Utilities
              </div>
            </template>
            <b-card class="border-0 mx-auto px-0 col-12">
              <GDQUtils />
            </b-card>
          </b-tab> -->
          <b-tab lazy class="px-0 col-12 border-0">
            <template v-slot:title>
              <div class="text-center">
                <fa-icon
                  class="mr-2"
                  name="chart-bar"
                /><br>Statistics
              </div>
            </template>
            <b-card class="border-0 mx-auto px-0 col-12">
              <Statistics />
            </b-card>
          </b-tab>
          <!-- <b-tab lazy class="px-0 col-12 border-0">
            <template v-slot:title>
              <div class="text-center">
                <fa-icon
                  class="mr-2"
                  name="wave-square"
                /><br>Planner
              </div>
            </template>
            <b-card class="border-0 mx-auto px-0 col-12">
              <Planner />
            </b-card>
          </b-tab> -->
          <b-tab v-if="user_id==1" lazy class="px-0 col-12 border-0">
            <template v-slot:title>
              <div class="text-center">
                <fa-icon
                  class="mr-2"
                  name="draw-polygon"
                /><br>Developer
              </div>
            </template>
            <b-card class="border-0 mx-auto px-0 col-12">
              <Developer />
            </b-card>
          </b-tab>
          <b-tab lazy class="px-0 col-12 border-0" style="height: 1000px !important">
            <template v-slot:title>
              <div class="text-center">
                <fa-icon
                  class="mr-2"
                  name="envelope"
                /><br>Bulk templates
              </div>
            </template>
            <b-card class="border-0 mx-auto px-0 col-12">
              <BulkMailDesign />
            </b-card>
          </b-tab>
          <!-- <b-tab lazy class="px-0 col-12 border-0" style="height: 1000px !important">
            <template v-slot:title>
              <div class="text-center">
                <fa-icon
                  class="mr-2"
                  name="envelope"
                /><br>Test Mail Edit
              </div>
            </template>
            <b-card class="border-0 mx-auto px-0 col-12">
              <MailEditTest />
            </b-card>
          </b-tab>                                            -->
        </b-tabs>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Navbar from './Navbar';
import Consultants from './Consultants';
import Companies from './Companies';
import Partners from './Partners';
import GDPRErase from './GDPRErase';
import InvoiceReport from './InvoiceReport';
import Tutorials from './Tutorials';
import Materials from './Materials';
import SystemSettings from './SystemSettings';
import Maintenance from './Maintenance';
// import GDQUtils from './GDQUtils.vue';
import Statistics from './Statistics.vue';
// import Planner from './Planner.vue';
import Developer from './Developer.vue';
import BulkMailDesign from './BulkMailDesign.vue';
// import MailEditTest from './MailEditTest.vue';

export default {
  name: 'GDQAdmin',
  components: {
    Navbar,
    Consultants,
    Companies,
    Partners,
    GDPRErase,
    InvoiceReport,
    Tutorials,
    Materials,
    SystemSettings,
    Maintenance,
    // GDQUtils,
    Statistics,
    // Planner,
    Developer,
    BulkMailDesign,
    // MailEditTest,
  },
  data() {
    return {
      user_id: this.$store.state.user_id,
      user_name: this.$store.state.user.first_name+' '+this.$store.state.user.family_name,
    }
  },
  mounted() {
    this.resetstuff();
    this.usergroups_get();
  },
  methods: {
    resetstuff() {
      this.$store.dispatch('consultant_setcurrent', { consultant_id: 0});
      this.$store.dispatch('company_setcurrent', { company_id: 0 });
    },
    usergroups_get() {
      this.$store.dispatch('usergroups_fetch');
    }
  }
}
</script>
